enum RefineStopReasons {
  MaxTokens = 'max_tokens'
};

export default RefineStopReasons;
